import '@/vendor/filepond-plugin-image-focalpoint-master/dist/filepond-plugin-focalpoint-edit.min.css';
import FilePondPluginFocalpointEdit from '@/vendor/filepond-plugin-image-focalpoint-master';

export default FilePondPluginFocalpointEdit;
